import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './App.css'
import Navigation from './components/Navigation'
import StarField from './components/StarField'
import HeroSection from './components/HeroSection'
import AboutSection from './components/AboutSection'
import SkillsSection from './components/SkillsSection'
import ProjectsSection from './components/ProjectsSection'
import ExperienceSection from './components/ExperienceSection'
import LabSection from './components/LabSection'
import DataIASection from './components/DataIASection'
import AnalyseDataPage from './pages/AnalyseDataPage'
import ContactSection from './components/ContactSection'
import Footer from './components/Footer'

export default function App() {
  const [activeSection, setActiveSection] = useState('hero')
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
      const sections = ['hero', 'about', 'skills', 'projects', 'experience', 'lab', 'data-ia', 'contact']
      for (const id of sections) {
        const el = document.getElementById(id)
        if (el) {
          const rect = el.getBoundingClientRect()
          if (rect.top <= 120 && rect.bottom >= 120) {
            setActiveSection(id)
            break
          }
        }
      }
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/analyse-data" element={<AnalyseDataPage />} />
          <Route path="/" element={
            <>
              <StarField />
              <Navigation activeSection={activeSection} scrollY={scrollY} />
              <main>
                <HeroSection />
                <AboutSection />
                <SkillsSection />
                <ProjectsSection />
                <ExperienceSection />
                <LabSection />
                <DataIASection />
                <ContactSection />
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  )
}
